export const INVESTMENTS_GET_REQUEST = 'investments/GET_REQUEST';
export const INVESTMENTS_GET_SUCCESS = 'investments/GET_SUCCESS';
export const INVESTMENTS_GET_ERROR = 'investments/GET_ERROR';

export const INVESTMENTS_BY_ID_GET_REQUEST = 'investments/byId/GET_REQUEST';
export const INVESTMENTS_BY_ID_GET_SUCCESS = 'investments/byId/GET_SUCCESS';
export const INVESTMENTS_BY_ID_GET_ERROR = 'investments/byId/GET_ERROR';
